









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'PaymentUserAction' })
export default class PaymentUserAction extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;
}
